<template>
<div class="login">
  <div class="container h-100  d-flex flex-column justify-content-center">
    <div class="tab-content w-100 w-sm-75 mx-auto" id="pills-tabContent">
      <div
        class="tab-pane fade show active"
        id="pills-log"
        role="tabpanel"
        aria-labelledby="pills-log-tab">
          <div class="card mb-3 shadow-lg horizontal">
            <div class="w-50 d-none d-sm-block">
              <img src="@/assets/img/log-img.png" class="card-img-top img-fluid" alt="log-photo">
            </div>
            <div class="card-body d-flex flex-column justify-content-between">
              <div class="mx-auto">
                <img src="@/assets/img/logo.png" alt="Logo">
              </div>
              <form class="d-flex align-items-center flex-column h-75 h-sm-60">
                <div class="form-group w-75 mb-0 mb-lg-5">
                  <label for="exampleInputEmail" class="d-flex align-items-center input-box">
                    <i class="lar la-lg la-envelope"></i>
                    <input type="email"
                      class="form-control"
                      id="exampleInputEmail"
                      aria-describedby="emailHelp"
                      placeholder="Enter email"
                      v-model.trim="signInMail"
                      >
                  </label>
                  <small class="form-text brown" v-if="logInMailError">{{ logInMailError }}</small>
                </div>
                <div class="form-group w-75">
                  <label for="exampleInputPassword" class="d-flex align-items-center input-box">
                    <i class="las la-lg la-lock"></i>
                    <input type="password"
                      class="form-control"
                      id="exampleInputPassword"
                      placeholder="Password"
                      v-model.trim="signInPwd"
                      @keyup.enter="login"
                      >
                  </label>
                  <small class="form-text brown" v-if="logInPwdError">{{ logInPwdError }}</small>
                </div>
                <div class="form-row w-75">
                  <div class="col-6 col-lg-7 d-flex align-items-center">
                    <div class="form-group custom-control custom-switch m-0">
                      <input type="checkbox"
                        class="custom-control-input"
                        id="exampleCheck"
                        v-model="rememberMe"
                        >
                      <label class="custom-control-label" for="exampleCheck">記住我</label>
                    </div>
                  </div>
                  <div class="col-6 col-lg-5 d-flex justify-content-end">
                    <button type="button" class="btn btn-link brown brownHover" data-toggle="modal" data-target=".forget-password">忘記密碼?</button>
                  </div>
                </div>
                <button type="submit" class="btn btn-primary btn-block mt-auto mb-2 mb-lg-5 w-75 signIn-btn" @click="login">登入</button>
              </form>
            </div>
          </div>
        </div>
      <div
        class="tab-pane fade"
        id="pills-regde"
        role="tabpanel"
        aria-labelledby="pills-regde-tab">
          <div class="card mb-3 shadow-lg horizontal regde-box">
            <div class="w-50 d-none d-sm-block">
              <img src="@/assets/img/log-img.png" class="card-img-top img-fluid" alt="log-photo">
            </div>
            <div class="card-body d-flex flex-column justify-content-between">
              <div class="mx-auto">
                <img src="@/assets/img/logo.png" alt="Logo">
              </div>
              <form class="d-flex align-items-center flex-column h-75">
                <div class="form-group w-75 mb-0 mb-lg-5">
                  <label for="exampleInputEmail-regde" class="d-flex align-items-center input-box">
                    <i class="lar la-lg la-envelope"></i>
                    <input type="email"
                      class="form-control"
                      id="exampleInputEmail-regde"
                      aria-describedby="emailHelp"
                      placeholder="Enter email"
                      v-model.trim="regdeMail"
                      >
                  </label>
                  <small class="form-text brown" v-if="regdeMailError">{{ regdeMailError }}</small>
                </div>
                <div class="form-group w-75 mb-0 mb-lg-5">
                  <label for="exampleInputPassword-regde" class="d-flex align-items-center input-box">
                    <i class="las la-lg la-lock"></i>
                    <input type="password"
                      class="form-control"
                      id="exampleInputPassword-regde"
                      placeholder="Password"
                      v-model.trim="regdePwd"
                      >
                  </label>
                  <small class="form-text brown" v-if="regdePwdError">{{ regdePwdError }}</small>
                </div>
                <div class="form-group w-75 mb-0 mb-lg-5">
                  <label for="exampleInputPasswordAgain-regde" class="d-flex align-items-center input-box">
                    <i class="las la-lg la-lock"></i>
                    <input type="password"
                      class="form-control"
                      id="exampleInputPasswordAgain-regde"
                      placeholder="Password Again"
                      v-model.trim="regdePwdAgain"
                      >
                  </label>
                  <small class="form-text brown" v-if="regdePwdAgainError">{{ regdePwdAgainError }}</small>
                </div>
                <div class="form-group w-75">
                  <div class="form-row">
                    <div class="col-12 col-lg-7">
                      <label for="exampleInputVerification-regde" class="d-flex align-items-center input-box">
                        <i class="las la-lg la-keyboard"></i>
                        <input type="text"
                          class="form-control"
                          id="exampleInputVerification-regde"
                          placeholder="驗證碼"
                          v-model.trim="regdeVerification"
                          >
                      </label>
                    </div>
                    <div class="col-12 col-lg-5 align-self-end mb-2">
                      <button type="button" class="btn btn-primary btn-sm signIn-btn btn-block" @click="Captcha">發送到E-mail</button>
                    </div>
                  </div>
                  <small class="form-text brown" v-if="regdeVerificationError">{{ regdeVerificationError }}</small>
                </div>
                <div class="form-row w-75">
                  <div class="form-group custom-control custom-switch m-0">
                    <input type="checkbox"
                      class="custom-control-input"
                      id="exampleCheck-regde"
                      v-model="IAgree"
                      >
                    <label class="custom-control-label" for="exampleCheck-regde">我同意<a href="#" class="brown brownHover">隱私條款</a></label>
                    <small class="form-text brown" v-if="regdeAgreeError">{{ regdeAgreeError }}</small>
                  </div>
                </div>
                <button type="submit" class="btn btn-primary btn-block mt-auto mb-2 w-75 signIn-btn" @click="registered">註冊</button>
              </form>
            </div>
          </div>
      </div>
    </div>
    <ul class="nav nav-pills w-auto mx-auto" id="pills-tab" role="tablist">
      <li class="nav-item" v-show="!InputWindow">
        <span>還不是會員?</span>
        <a
          class="btn-link brown active"
          id="pills-log-tab"
          data-toggle="pill"
          href="#pills-log"
          role="tab"
          aria-controls="pills-log"
          aria-selected="true"
          @click="InputWindow = !InputWindow"
        >登入</a>
      </li>
      <li class="nav-item" v-show="InputWindow">
        <span>已經是會員?</span>
        <a
          class="btn-link brown"
          id="pills-regde-tab"
          data-toggle="pill"
          href="#pills-regde"
          role="tab"
          aria-controls="pills-regde"
          aria-selected="false"
          @click="InputWindow = !InputWindow"
        >註冊</a>
      </li>
    </ul>
  </div>
  <div class="modal fade forget-password" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-sm">
      <div class="modal-content modal-bg">
        <div class="modal-header border-0 pb-0">
          <h5 class="modal-title" id="exampleModalCenterTitle">電子郵件</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
        <small class="brown" v-if="temporaryMailError">{{ temporaryMailError }}</small>
            <input type="email"
              class="form-control"
              id="exampleInputEmail1"
              aria-describedby="emailHelp"
              placeholder="Enter email"
              v-model.trim="temporaryMail"
              >
          <div class="mt-4 d-flex justify-content-end">
            <button type="button" class="btn btn-secondary mr-3 shadow" data-dismiss="modal">返回</button>
            <button type="button" class="btn btn-primary signIn-btn" @click="forgetPassword">發送</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="modal fade registration-verification" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-sm">
      <div class="modal-content modal-bg">
        <div class="modal-header  border-0 pb-0">
          <h5 class="modal-title" id="exampleModalCenterTitle">取得驗證碼</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <input type="text"
            class="form-control form-control-sm"
            id="cellPhoneNumber"
            aria-describedby="numberHelp"
            placeholder="0912345678"
            v-model.trim="temporaryPhone"
            >
          <div class="mt-4 d-flex justify-content-end">
            <button type="button" class="btn btn-secondary mr-3 shadow" data-dismiss="modal">返回</button>
            <button type="button" class="btn btn-primary signIn-btn">發送</button>
          </div>
        </div>
      </div>
    </div>
  </div> -->
</div>
</template>

<script>
import $ from 'jquery'

export default {
  data () {
    return {
      InputWindow: true,
      rememberMe: false,
      signInMail: '',
      signInPwd: '',
      regdeMail: '',
      regdePwd: '',
      regdePwdAgain: '',
      regdeVerification: '',
      IAgree: false,
      temporaryMail: '',
      logInMailError: '',
      logInPwdError: '',
      temporaryMailError: '',
      regdeMailError: '',
      regdeVerificationError: '',
      regdePwdError: '',
      regdePwdAgainError: '',
      regdeAgreeError: ''
    }
  },
  methods: {
    login () {
      const reg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
      if (!reg.test(this.signInMail)) {
        this.logInMailError = 'Email格式不完整...'
      } else {
        this.logInMailError = ''
        if (this.signInPwd === '') {
          this.logInPwdError = '密碼還沒寫喔~'
        } else {
          this.logInPwdError = ''
          const vm = this
          const url = 'http://imrebooksystem.rocket-coding.com/BusinessUsers/Login'
          this.axios.post(url, {
            rememberMe: vm.rememberMe,
            Email: vm.signInMail,
            Password: vm.signInPwd
          })
            .then(function (res) {
              if (res.data !== '登入成功') {
                vm.logInMailError = res.data
              } else {
                if (vm.rememberMe === true) {
                  localStorage.setItem('rememberUser', JSON.stringify(vm.signInMail))
                } else if (vm.rememberMe === false) {
                  localStorage.removeItem('rememberUser')
                }
                vm.$swal({
                  position: 'top-end',
                  background: '#F7ECEB',
                  icon: 'success',
                  title: res.data,
                  showConfirmButton: false,
                  toast: true,
                  timer: 3000,
                  timerProgressBar: true,
                  onOpen: (toast) => {
                    toast.addEventListener('mouseenter', vm.$swal.stopTimer)
                    toast.addEventListener('mouseleave', vm.$swal.resumeTimer)
                  }
                })
                sessionStorage.setItem('admin', JSON.stringify(vm.signInMail))
                vm.signInMail = ''
                vm.signInPwd = ''
                vm.rememberMe = false
                localStorage.setItem('status', 'true') // 登入狀態
                vm.$router.push('/backstage')
              }
            })
            .catch(error => console.error(error))
        }
      }
    },
    forgetPassword () {
      const reg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
      if (!reg.test(this.temporaryMail)) {
        this.temporaryMailError = '格式不完整...'
      } else {
        const vm = this
        const url = 'http://imrebooksystem.rocket-coding.com/BusinessUsers/TemporaryPassword'
        this.axios.post(url, { Email: vm.temporaryMail })
          .then(function (res) {
            if (res.data.length !== 8) {
              vm.temporaryMailError = res.data
            } else {
              vm.temporaryMailError = ''
              vm.temporaryMail = ''
              $('.forget-password').modal('hide')
              vm.$swal({
                position: 'top-end',
                background: '#F7ECEB',
                icon: 'success',
                title: '已發送到信箱',
                showConfirmButton: false,
                toast: true,
                timer: 3000,
                timerProgressBar: true,
                onOpen: (toast) => {
                  toast.addEventListener('mouseenter', vm.$swal.stopTimer)
                  toast.addEventListener('mouseleave', vm.$swal.resumeTimer)
                }
              })
            }
          })
          .catch(error => console.error(error))
      }
    },
    Captcha () {
      const reg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
      if (!reg.test(this.regdeMail)) {
        this.regdeMailError = '請先填寫 E-mail...'
      } else {
        const vm = this
        const url = 'http://imrebooksystem.rocket-coding.com/businessUsers/VerificationMailSend'
        this.axios.post(url, { Email: vm.regdeMail })
          .then(function (res) {
            localStorage.setItem('verification', JSON.stringify(res.data))
            if (typeof (res.data) === 'number') {
              vm.regdeMailError = ''
              vm.$swal({
                position: 'top-end',
                background: '#F7ECEB',
                icon: 'success',
                title: '已發送到信箱',
                showConfirmButton: false,
                toast: true,
                timer: 3000,
                timerProgressBar: true,
                onOpen: (toast) => {
                  toast.addEventListener('mouseenter', vm.$swal.stopTimer)
                  toast.addEventListener('mouseleave', vm.$swal.resumeTimer)
                }
              })
            } else {
              vm.regdeMailError = res.data
            }
          })
          .catch(error => console.error(error))
      }
    },
    registered () {
      const reg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
      if (!reg.test(this.regdeMail)) {
        this.regdeMailError = '請先填寫 E-mail...'
      } else if (this.regdePwd === '') {
        this.regdeMailError = ''
        this.regdePwdError = '還沒填寫密碼喔~'
      } else if (this.regdePwd !== this.regdePwdAgain) {
        this.regdeMailError = ''
        this.regdePwdError = ''
        this.regdePwdAgainError = '密碼不相同'
      } else if (this.regdeVerification === '') {
        this.regdeMailError = ''
        this.regdePwdError = ''
        this.regdePwdAgainError = ''
        this.regdeVerificationError = '還沒取得驗證碼嗎?'
      } else if (this.regdeVerification !== localStorage.getItem('verification')) {
        this.regdeMailError = ''
        this.regdePwdError = ''
        this.regdePwdAgainError = ''
        this.regdeVerificationError = '驗證碼不對喔~'
      } else if (this.IAgree === false) {
        this.regdeMailError = ''
        this.regdePwdError = ''
        this.regdePwdAgainError = ''
        this.regdeVerificationError = ''
        this.regdeAgreeError = '還沒點選我同意喔~'
      } else {
        this.regdeMailError = ''
        this.regdePwdError = ''
        this.regdePwdAgainError = ''
        this.regdeVerificationError = ''
        this.regdeAgreeError = ''
        const vm = this
        const url = 'http://imrebooksystem.rocket-coding.com/BusinessUsers/create'
        this.axios.post(url, {
          Email: vm.regdeMail,
          Password: vm.regdePwd,
          Verification: vm.regdeVerification
        })
          .then(function (res) {
            if (res.data !== '註冊成功') {
              vm.$swal({
                position: 'top-end',
                background: '#F7ECEB',
                icon: 'error',
                title: res.data,
                showConfirmButton: false,
                toast: true,
                timer: 3000,
                timerProgressBar: true,
                onOpen: (toast) => {
                  toast.addEventListener('mouseenter', vm.$swal.stopTimer)
                  toast.addEventListener('mouseleave', vm.$swal.resumeTimer)
                }
              })
              vm.$router.push('/backstage')
            } else {
              vm.$swal({
                position: 'top-end',
                background: '#F7ECEB',
                icon: 'success',
                title: '註冊成功',
                showConfirmButton: false,
                toast: true,
                timer: 3000,
                timerProgressBar: true,
                onOpen: (toast) => {
                  toast.addEventListener('mouseenter', vm.$swal.stopTimer)
                  toast.addEventListener('mouseleave', vm.$swal.resumeTimer)
                }
              })
              vm.regdeMail = ''
              vm.regdePwd = ''
              vm.regdePwdAgain = ''
              vm.regdeVerification = ''
              vm.IAgree = false
            }
          })
          .catch(error => console.error(error))
      }
    }
  },
  created () {
    const data = JSON.parse(localStorage.getItem('rememberUser'))
    if (data !== null) {
      this.rememberMe = true
      this.signInMail = data
    }
  }
}
</script>

<style lang="scss">
.btn:active {
   outline: none !important;
   box-shadow: none !important;
}
.brownHover:hover{
  color: rgb(153, 107, 104);
}
.h-60 {
    height: 60%!important;
}
.login {
  width: 100%;
  height: 100vh;
  background-color: #545871;
}
.horizontal{
  flex-direction: row;
  background-color: #F7ECEB;
  border: 0;
}
.input-box{
  border-bottom: 1.5px solid #545871;
  color: #545871;
  input::-webkit-input-placeholder {
  color: #B8817D;
  }
  input,
  input:active,
  input:focus,
  input:hover{
    background-color: transparent;
    -webkit-text-fill-color: #B8817D;//字體顏色
    border: 0;
    box-shadow:transparent;//input背景色
    transition: background-color 5000s ease-in-out 0s; //透明
  }
}
.custom-control-input:checked~.custom-control-label::before{
  border-color: #B8817D;
  background-color: #B8817D;
}
.custom-control-input:focus~.custom-control-label::before {
  box-shadow: none !important;
}
.custom-control-input:focus:not(:checked)~.custom-control-label::before {
  border-color: #adb5bd !important;
}
.custom-control-input:active:not(:checked)~.custom-control-label::before {
  background-color: rgba(184, 129, 125, 0.274) !important;
  border-color: transparent !important;
}
.custom-control-input:active~.custom-control-label::before {
  background-color: rgba(184, 129, 125, 0.274) !important;
  border-color: transparent !important;
}
.signIn-btn{
  background-color: #545871;
  color: #F7ECEB;
  border: 0px;
  box-shadow: 0px 10px 13px 1px #B8A7A7;
}
.signIn-btn:hover{
  background-color: #6f738b;
}
.signIn-btn:active{
  background-color: #545871 !important;
}
.signIn-btn:focus{
  background-color: #545871;
  box-shadow: 0px 10px 13px 1px #B8A7A7;
}
@media (min-width: 576px){
  .h-sm-60 {
    height: 60%!important;
  }

}
@media (max-width: 576px){
  .horizontal{
    max-height: 510px;
  }
  .regde-box{
    height: 550px;
  }
}
.modal-bg{
  background-color: #F7ECEB;
  color: #545871;
  input::-webkit-input-placeholder {
  color: #B8817D;
  }
  input,
  input:active,
  input:focus,
  input:hover{
    background-color: transparent;
    -webkit-text-fill-color: #B8817D;//字體顏色
    border: 1px solid #54587162;
    box-shadow:transparent;//input背景色
    transition: background-color 5000s ease-in-out 0s; //透明
  }
}
</style>
